var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sd-btn",style:({ backgroundColor: _vm.color }),attrs:{"type":"button"}},[_c('Icon',{attrs:{"src":"speaker"}}),_c('span',[_vm._v(_vm._s(_vm.$t('listenTo')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }